import { LinkExpireSettings } from './link-expire-settings';
import { PasswordSettings } from './password-settings';
import { PublicToggle } from './public-toggle';
import { ShareLinkInput } from './share-link-input';
import {
  type SharedLinkForm,
  SharedLinkFormProvider,
} from './shared-link-form-context';

type Props = {
  form: SharedLinkForm;
};

export function SharedLinkForm({ form }: Props) {
  return (
    <SharedLinkFormProvider form={form}>
      <div className="flex flex-col gap-6">
        <PublicToggle />
        <ShareLinkInput />
        <form.AppField
          name="isPublic"
          children={(isPublicField: any) =>
            isPublicField.state.value ? (
              <div className="flex flex-col gap-5">
                <h3 className="text-sm font-semibold text-gray-900">Settings</h3>
                <LinkExpireSettings />
                <PasswordSettings />
              </div>
            ) : null
          }
        />
      </div>
    </SharedLinkFormProvider>
  );
}
